



















import { Component, Prop, Vue } from 'vue-property-decorator';
import { Spinner as LoadingSpinner } from '@/components/spinners';
import { SuccessMessage, RequestForm } from './components';

@Component({
  components: {
    RequestForm,
    LoadingSpinner,
    SuccessMessage,
  },
})
export default class VacancyRespondForm extends Vue {
  @Prop({ type: Boolean, default: false })
  readonly isLoading!: boolean;

  @Prop({ type: Boolean, default: false })
  readonly isMessage!: boolean;

  @Prop({ type: Boolean, default: false })
  readonly isError!: boolean;

  @Prop({ type: String, default: '' })
  readonly errorMessage!: string;

  submitRespond(request: any) {
    this.$emit('submitRespond', request);
  }

  cancelRespond() {
    this.$emit('cancelRespond');
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/vacancies/form/VacancyRespondForm.vue